import { d as defineCustomElement } from '../chunks/vidstack-B11i_cNc.js';
import { h as MediaLayoutElement, c as MediaControlsElement, d as MediaControlsGroupElement, b as MediaAnnouncerElement, k as MediaTooltipElement, l as MediaTooltipTriggerElement, m as MediaTooltipContentElement, i as MediaGoogleCastButtonElement, j as MediaToggleButtonElement, s as MediaSliderElement, u as MediaAudioGainSliderElement, v as MediaSpeedSliderElement, w as MediaQualitySliderElement, x as MediaSliderChaptersElement, y as MediaSliderStepsElement, t as MediaSliderVideoElement, n as MediaMenuPortalElement, p as MediaAudioGainRadioGroupElement, o as MediaChaptersRadioGroupElement, r as MediaRadioGroupElement, q as MediaRadioElement, a as MediaGestureElement, M as MediaCaptionsElement, e as MediaTitleElement, f as MediaChapterTitleElement, g as MediaSpinnerElement } from '../chunks/vidstack-CBPFsxaq.js';
import { h as MediaPlayButtonElement, f as MediaMuteButtonElement, c as MediaCaptionButtonElement, d as MediaFullscreenButtonElement, g as MediaPIPButtonElement, i as MediaSeekButtonElement, b as MediaAirPlayButtonElement, v as MediaVolumeSliderElement, t as MediaTimeSliderElement, u as MediaSliderPreviewElement, s as MediaSliderValueElement, r as MediaSliderThumbnailElement, l as MediaMenuElement, m as MediaMenuButtonElement, o as MediaMenuItemsElement, n as MediaMenuItemElement, j as MediaAudioRadioGroupElement, k as MediaCaptionsRadioGroupElement, p as MediaSpeedRadioGroupElement, q as MediaQualityRadioGroupElement, M as MediaThumbnailElement, e as MediaLiveButtonElement, a as MediaTimeElement } from '../chunks/vidstack-CdHBcYUs.js';
import { MediaPosterElement } from '../chunks/vidstack-CyVF_YzU.js';
import '../chunks/vidstack-BPJwxG0c.js';
import '../chunks/vidstack-CNLrsPpJ.js';
import '../chunks/vidstack-VrKElWm_.js';
import '../chunks/vidstack-BnqIpPdq.js';
import '../chunks/vidstack-NiSULkLR.js';
import '../chunks/vidstack-CzvK2UwB.js';
import '../chunks/vidstack-COCzjeeM.js';
import '../chunks/vidstack-CUVgUi9M.js';
import '../chunks/vidstack-BSXZsAhp.js';
import '../chunks/vidstack-DM_McBs5.js';
import '../chunks/vidstack-ksPACRiU.js';
import '../chunks/vidstack-BEFqUV5_.js';
import '../chunks/vidstack-Bf6opHxk.js';
import '../chunks/vidstack-rsZGrNIW.js';
import '../chunks/vidstack-CJAQyhUi.js';

defineCustomElement(MediaLayoutElement);
defineCustomElement(MediaControlsElement);
defineCustomElement(MediaControlsGroupElement);
defineCustomElement(MediaPosterElement);
defineCustomElement(MediaAnnouncerElement);
defineCustomElement(MediaTooltipElement);
defineCustomElement(MediaTooltipTriggerElement);
defineCustomElement(MediaTooltipContentElement);
defineCustomElement(MediaPlayButtonElement);
defineCustomElement(MediaMuteButtonElement);
defineCustomElement(MediaCaptionButtonElement);
defineCustomElement(MediaFullscreenButtonElement);
defineCustomElement(MediaPIPButtonElement);
defineCustomElement(MediaSeekButtonElement);
defineCustomElement(MediaAirPlayButtonElement);
defineCustomElement(MediaGoogleCastButtonElement);
defineCustomElement(MediaToggleButtonElement);
defineCustomElement(MediaSliderElement);
defineCustomElement(MediaAudioGainSliderElement);
defineCustomElement(MediaVolumeSliderElement);
defineCustomElement(MediaTimeSliderElement);
defineCustomElement(MediaSpeedSliderElement);
defineCustomElement(MediaQualitySliderElement);
defineCustomElement(MediaSliderChaptersElement);
defineCustomElement(MediaSliderStepsElement);
defineCustomElement(MediaSliderPreviewElement);
defineCustomElement(MediaSliderValueElement);
defineCustomElement(MediaSliderThumbnailElement);
defineCustomElement(MediaSliderVideoElement);
defineCustomElement(MediaMenuElement);
defineCustomElement(MediaMenuButtonElement);
defineCustomElement(MediaMenuPortalElement);
defineCustomElement(MediaMenuItemsElement);
defineCustomElement(MediaMenuItemElement);
defineCustomElement(MediaAudioRadioGroupElement);
defineCustomElement(MediaCaptionsRadioGroupElement);
defineCustomElement(MediaSpeedRadioGroupElement);
defineCustomElement(MediaAudioGainRadioGroupElement);
defineCustomElement(MediaQualityRadioGroupElement);
defineCustomElement(MediaChaptersRadioGroupElement);
defineCustomElement(MediaRadioGroupElement);
defineCustomElement(MediaRadioElement);
defineCustomElement(MediaGestureElement);
defineCustomElement(MediaThumbnailElement);
defineCustomElement(MediaCaptionsElement);
defineCustomElement(MediaLiveButtonElement);
defineCustomElement(MediaTimeElement);
defineCustomElement(MediaTitleElement);
defineCustomElement(MediaChapterTitleElement);
defineCustomElement(MediaSpinnerElement);
